import React, { useRef, useState, useEffect } from "react";
import {
    I2cRadioGroup, I2cRadioButton
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { Controller } from "react-hook-form";
import { CheckboxRenderer, InputRenderer, CheckboxTableRenderer, HeaderCheckboxRenderer } from "./CellRenderer";
import { I2cDataTable } from '@webcomponents/i2cwebcomponents/dist/react';
import { business_loginInfo, business_accountInfo, business_additionalCardInfo, business_documentationInfo, business_employeeInfo, business_businessOwnerInfo, business_businessInfo } from './stringUtils';
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons";

const BusinessDataTables = ({ type, control, handleValueChanges, methods, errors, appSelectionForProgram, isFormDataUpdated }) => {
    const [gridOptionsLoginInfo, setGridOptionsLoginInfo] = useState({});
    const [gridOptionsBusinessInfo, setGridOptionsBusinessInfo] = useState({});
    const [gridOptionsOwnerInfo, setGridOptionsOwnerInfo] = useState({});
    const [gridOptionsEmployeeInfo, setGridOptionsEmployeeInfo] = useState({});
    const [gridOptionsDocumentation, setGridOptionsDocumentation] = useState({});
    const [gridOptionsCardInfo, setGridOptionsCardInfo] = useState({});
    const [gridOptionsAccountInfo, setGridOptionsAccountInfo] = useState({});
    const tableRefs = {
        business_login_info: useRef(null),
        business_business_info: useRef(null),
        business_business_owner_info: useRef(null),
        business_employee_info: useRef(null),
        business_documentation: useRef(null),
        business_additional_card_info: useRef(null),
        business_account_info: useRef(null),
    };
    const tables = [
        { id: 'business_login_info', dataKey: 'card_enrollment_fields_for_business_login_info', tableName: "Login Information", initialData: business_loginInfo, stateSetter: setGridOptionsLoginInfo },
        { id: 'business_business_info', dataKey: 'card_enrollment_fields_for_business_business_info', tableName: "Business Information", initialData: business_businessInfo, stateSetter: setGridOptionsBusinessInfo },
        { id: 'business_business_owner_info', dataKey: 'card_enrollment_fields_for_business_business_owner_info', tableName: "Business Owner Information", initialData: business_businessOwnerInfo, stateSetter: setGridOptionsOwnerInfo },
        { id: 'business_employee_info', dataKey: 'card_enrollment_fields_for_business_employee_info', tableName: "Employee Information", initialData: business_employeeInfo, stateSetter: setGridOptionsEmployeeInfo },
        { id: 'business_documentation', dataKey: 'card_enrollment_fields_for_business_documentation', tableName: "Documentation", initialData: business_documentationInfo, stateSetter: setGridOptionsDocumentation },
        { id: 'business_additional_card_info', dataKey: 'card_enrollment_fields_for_business_additional_card_info', tableName: "Additional Card Info", initialData: business_additionalCardInfo, stateSetter: setGridOptionsCardInfo },
        { id: 'business_account_info', dataKey: 'card_enrollment_fields_for_business_account_info', tableName: "Account Information", initialData: business_accountInfo, stateSetter: setGridOptionsAccountInfo },
    ];
    useEffect(() => {
        tables.forEach((table) => {
            const backendData = methods.getValues(table.dataKey);
            const gridOptions = (backendData?.length > 0 ?
                {
                    columnDefs: [
                        { headerName: 'Enrollment Field', field: 'enrollment_field', editable: true },
                        { headerName: 'Enable', field: 'enable', cellRenderer: CheckboxTableRenderer, headerComponent: HeaderCheckboxRenderer },
                        { headerName: 'Mandatory', field: 'mandatory', cellRenderer: CheckboxTableRenderer, headerComponent: HeaderCheckboxRenderer }
                    ],
                    rowSelection: 'single',
                    rowData: backendData,
                    suppressMoveWhenRowDragging: true,
                    context: { methods, handleValueChanges, tableType: table.dataKey }
                }
                :
                {
                    columnDefs: [
                        { headerName: 'Enrollment Field', field: 'enrollment_field', editable: true },
                        { headerName: 'Enable', field: 'enable', cellRenderer: InputRenderer },
                        { headerName: 'Mandatory', field: 'mandatory', cellRenderer: InputRenderer }
                    ],
                    rowSelection: 'single',
                    rowData: table.initialData || [],
                    suppressMoveWhenRowDragging: true,
                    context: { methods, handleValueChanges, tableType: table.dataKey }
                }
            );
            table.stateSetter(gridOptions);
            const api = tableRefs[table.id]?.current?.getGridApi();
            if (api) {
                api.setRowData && api.setRowData(backendData?.length > 0 ? backendData : table.initialData || []);
            }
        });
    }, [isFormDataUpdated]);

    return (
        <>
            <div i2c-grid="grid gap-md">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Business Enrollment (For the Web App only)
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label mb-8">
                        Please select enrollment fields for business credit programs.
                    </div>
                    <div className="section-tables-containers">
                        <div i2c-grid="grid gap-md">
                            {tables.map((table) => (
                                <>
                                    <div i2c-grid="12" className="cholder-label-heading">
                                        {table.tableName}
                                    </div>
                                    <div i2c-grid="12">
                                        <Controller
                                            key={table.id}
                                            name={table.dataKey}
                                            control={control}
                                            render={({ field }) => (
                                                <I2cDataTable
                                                    id={`dataTable_${table.id}`}
                                                    ref={tableRefs[table.id]}
                                                    gridOptionInput={
                                                        table.id === 'business_login_info' ? gridOptionsLoginInfo :
                                                            table.id === 'business_business_info' ? gridOptionsBusinessInfo :
                                                                table.id === 'business_business_owner_info' ? gridOptionsOwnerInfo :
                                                                    table.id === 'business_employee_info' ? gridOptionsEmployeeInfo :
                                                                        table.id === 'business_documentation' ? gridOptionsDocumentation :
                                                                            table.id === 'business_additional_card_info' ? gridOptionsCardInfo :
                                                                                gridOptionsAccountInfo
                                                    }
                                                    notFound={[
                                                        {
                                                            description: 'No data available. Please add some features or refresh the page.',
                                                            type: 'noData',
                                                            icon: 'outline-info-circle',
                                                            primaryBtn: `<i2c-button variant="primary" size='large'>Reload</i2c-button>`,
                                                        },
                                                    ]}
                                                />
                                            )}
                                        />
                                    </div>
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default BusinessDataTables;                  
